export const OPEN_EMOJI_DIALOG = "OPEN_EMOJI_DIALOG";
export const CLOSE_EMOJI_DIALOG = "CLOSE_EMOJI_DIALOG";

export const GET_EMOJI = "GET_EMOJI";
export const CREATE_NEW_EMOJI = "CREATE_NEW_EMOJI";
export const EDIT_EMOJI = "EDIT_EMOJI";
export const DELETE_EMOJI = "DELETE_EMOJI";
export const DELETE_ALL_EMOJI = "DELETE_ALL_EMOJI";

export const SET_CREATE_EMOJI_DONE = "SET_CREATE_EMOJI_DONE";
export const UNSET_CREATE_EMOJI_DONE = "UNSET_CREATE_EMOJI_DONE";

export const SET_UPDATE_EMOJI_DONE = "SET_UPDATE_EMOJI_DONE";
export const UNSET_UPDATE_EMOJI_DONE = "UNSET_UPDATE_EMOJI_DONE";
